import {
  QUESTION_ANSWER_ROUTE_NAME,
  ROOM_BIBLES_ROUTE_NAME,
  ROOM_CHECKLIST_ROUTE_NAME,
  ROOM_DOCUMENTS_ROUTE_NAME,
  ROOM_LOGS_ROUTE_NAME,
  ROOM_MEMBERS_ROUTE_NAME,
  ROOM_SETTINGS_ROUTE_NAME,
  ROOM_SIGNED_DOCUMENTS_ROUTE_NAME,
  ROOMS_ROUTE_NAME,
  SIGNING_CHECKLIST_ROUTE_NAME,
} from '@/router/index.ts'

export const projectPages = {
  [ROOMS_ROUTE_NAME]: {
    translationKey: 'home',
    icon: 'house',
  },
  [ROOM_MEMBERS_ROUTE_NAME]: {
    translationKey: 'participants',
    icon: 'group',
  },
  [ROOM_DOCUMENTS_ROUTE_NAME]: {
    translationKey: 'documents',
    icon: 'folder_open',
  },
  [ROOM_CHECKLIST_ROUTE_NAME]: {
    translationKey: 'checklist',
    icon: 'checklist',
  },
  [SIGNING_CHECKLIST_ROUTE_NAME]: {
    translationKey: 'signing-checklist',
    icon: 'signature',
  },
  [ROOM_SIGNED_DOCUMENTS_ROUTE_NAME]: {
    translationKey: 'signedDocuments',
    icon: 'task',
  },
  [ROOM_BIBLES_ROUTE_NAME]: {
    translationKey: 'bibles',
    icon: 'book_2',
  },
  [ROOM_SETTINGS_ROUTE_NAME]: {
    translationKey: 'settings',
    icon: 'settings',
  },
  [QUESTION_ANSWER_ROUTE_NAME]: {
    translationKey: 'qa',
    icon: 'forum',
  },
  [ROOM_LOGS_ROUTE_NAME]: {
    translationKey: 'logs',
    icon: 'history',
  },
}

export function getRoomNavigationDataFromRoute(route) {
  const routeName = route.name

  if (projectPages[routeName]) {
    return projectPages[routeName]
  }

  // Check if the route is a child of room section
  if (route.matched) {
    for (const matchedRoute of route.matched) {
      if (matchedRoute.name && projectPages[matchedRoute.name]) {
        return projectPages[matchedRoute.name]
      }
    }
  }

  return null
}
